// components/BlogLayout.js
import React from "react";
import { Row, Col } from "reactstrap";
import { ArticleContent } from "../style/Blog";
import CardClotereSidebarQuestion from "./CardClotereSidebarQuestion";
import Footer from "../components/Footer";
import ArticlesSimilaires from "./ArticlesSimilaires";
import PrendreRdv from "../leadPage/prendreRdv";
import HeaderPost from "./HeaderPost";
import { Helmet } from "react-helmet";

export default function BlogLayout({
  children,
  metaTitle,
  metaDescription,
  ogImage,
  ogUrl,
  headerTitle,
  breadlink1 = "/blog",
  namelink1 = "Blog",
  namelinkActive = "Article",
  similairesType = "immobilier"
}) {
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:url" content={ogUrl} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content={ogImage} />
      </Helmet>

      <HeaderPost
        titre={headerTitle}
        breadlink1={breadlink1}
        namelink1={namelink1}
        namelinkActive={namelinkActive}
      />

      <div>
        <ArticleContent>
          <section className="content">
            <div className="container relative">
              <Row>
                <Col className="col-sm-9 col-xs-12 article">{children}</Col>

                <div 
                className="col-sm-3 col-xs-0 hidden sm:block">
                  <CardClotereSidebarQuestion />
                </div>

                <div className="col-xs-0 sm:hidden">
                  <CardClotereSidebarQuestion />
                </div>
              </Row>
            </div>
          </section>
        </ArticleContent>

        <ArticlesSimilaires title="Articles similaires" type={similairesType} />
        <PrendreRdv />
        <Footer />
      </div>
    </>
  );
}